import BoldText from '@/components/BoldText';
import { Collapsible } from '@/components/Collapsible';
import RegularText from '@/components/RegularText';
import { WIDGET_DISPLAY_CHOICE } from '@/constants/enum';
import { PATH } from '@/constants/path';
import { StyledPadding } from '@/pages/GeneralSetting/styled';
import { generalSettingSelector, handleSaveSettings } from '@/redux/slice/setting.slice';
import { BlockStack, Box, Button, Card, Checkbox, Icon, InlineStack } from '@shopify/polaris';
import { DeliveryIcon } from '@shopify/polaris-icons';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export const LocalDelivery = () => {
  const { t } = useTranslation('general_settings');
  const generalSettings = useSelector(generalSettingSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <Collapsible
      title={
        <Box>
          <InlineStack gap={'200'}>
            <Box>
              <Icon source={DeliveryIcon} />
            </Box>
            <BoldText>{t('sections.advancedSetting.localDelivery.title')}</BoldText>
          </InlineStack>
          <StyledPadding paddingLeft="28px">
            <Box color="text-secondary">
              <RegularText fontWeight="regular">{t('sections.advancedSetting.localDelivery.helpText')}</RegularText>
            </Box>
          </StyledPadding>
        </Box>
      }
    >
      <Box paddingBlockStart={'300'}>
        <Card padding={'300'}>
          <BlockStack gap={'200'}>
            {generalSettings.displayOnPage.length === 1 &&
              generalSettings.displayOnPage.includes(WIDGET_DISPLAY_CHOICE.PRODUCT) && (
                <Box>
                  This feature is only available for those who{' '}
                  <Button variant="plain" onClick={() => navigate(PATH.WIDGET.pathname)}>
                    display the widget on the cart page.
                  </Button>{' '}
                </Box>
              )}
            <InlineStack gap="200" blockAlign="center">
              <BoldText fontWeight="medium">{t('sections.advancedSetting.localDelivery.checkoutTitle')}</BoldText>
            </InlineStack>
            <Checkbox
              label={<div>{t('sections.advancedSetting.localDelivery.checkoutPrepopulateLabel')}</div>}
              helpText={t('sections.advancedSetting.localDelivery.checkoutPrepopulateHelpText')}
              checked={generalSettings.isAutoFillDeliveryZipCode}
              onChange={() => {
                dispatch(handleSaveSettings({ isAutoFillDeliveryZipCode: !generalSettings.isAutoFillDeliveryZipCode }));
              }}
              disabled={
                generalSettings.displayOnPage.length === 1 &&
                generalSettings.displayOnPage.includes(WIDGET_DISPLAY_CHOICE.PRODUCT)
              }
            />
          </BlockStack>
        </Card>
      </Box>
    </Collapsible>
  );
};
